import type { ComponentProps } from 'react'

import { Toast } from '@base-ui/react'
import styled from 'styled-components'

const SnackbarDescription = styled.p`
	font-size: ${({ theme }) => theme.font.size.small};
	margin: 0;
	text-align: left;
`

type Props = ComponentProps<typeof Toast.Description>

export const Description = ({ ...rest }: Props) => (
	<Toast.Description {...rest} render={(props) => <SnackbarDescription {...props} />} />
)
